import { OptionDefinition } from "@amzn/awsui-components-react/polaris/internal/components/option/interfaces";
import { Ptc } from "../parsers/ptcParser";

export const worksheetToOption = (worksheet: string): OptionDefinition => ({ value: worksheet });

export const ptcToOption = (ptc: Ptc, description?: string): OptionDefinition => ({ value: ptc.ptcName, description });

export const requiredErrorText = (field: string) => `${field} is required`;
